const resources = {
    estimatedTotal: 'Estimated Total',
    merchandiseSubtotal: 'Merchandise Subtotal',
    giftCardShipping: 'Gift Card Shipping',
    merchandiseShipping: 'Merchandise Shipping',
    shippingAndHandling: 'Shipping & Handling',
    discounts: 'Discounts',
    gstHst: 'Estimated GST/HST',
    pst: 'Estimated PST',
    tax: 'Estimated Tax',
    andOtherFees: '& Other Fees',
    storeCreditRedeemed: 'Account Credit',
    giftCardRedeemed: 'Gift Card Redeemed',
    eGiftCardRedeemed: 'eGift Card Redeemed',
    creditCardPayment: 'Credit Card Payment',
    payPalPayment: 'PayPal Payment',
    submitEdits: 'Submit Edits',
    subscribe: 'Subscribe',
    placeOrder: 'Place Order',
    shippingHandling: 'Shipping & Handling',
    pickupText: 'Pickup',
    free: 'FREE',
    shippingHandlingInfo: 'Shipping & Handling Information',
    salesTax: 'Sales Tax',
    pointsUsed: 'Used',
    bagFee: 'Bag Fee',
    specialFee: 'Special Fee',
    pointsAfterPickup: 'You will earn Beauty Insider points from this purchase after you pick up the order.',
    gotIt: 'Got It',
    autoReplenishmentSavings: 'Auto-Replenish Savings',
    youSave: 'You save',
    sduSavingsUS: '$6.95',
    sduSavingsCA: '$9.95',
    withSDUUnlimited: 'with Same-Day Unlimited'
};

export default function getResource(label) {
    return resources[label] || label;
}
